module.exports = __webpack_public_path__ + "img/intro2.0696f0c3.png";